import { contentHeader } from "../../utils/header";
import { apiSlice } from "../apiSlice";

export const ChartApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    evictionByType: builder.query({
      query: (params) => ({
        url: "/evictiondata/evictions-by-type",
        method: "GET",
        params: params,
        headers: contentHeader(),
      }),
      providesTags: ["Chart"],
    }),

    evictionByMonth: builder.query({
      query: (params) => ({
        url: "/evictiondata/evictions-by-month",
        method: "GET",
        params: params,
        headers: contentHeader(),
      }),
      providesTags: ["Chart"],
    }),

    preventionsByMonth: builder.query({
      query: (params) => ({
        url: "/preventiondata/preventions-by-month",
        method: "GET",
        params: params,
        headers: contentHeader(),
      }),
      providesTags: ["Chart"],
    }),

    incidenceByEntity: builder.query({
      query: (params) => ({
        url: "/evictiondata/evictions-by-entity",
        method: "GET",
        params: params,
        headers: contentHeader(),
      }),
      providesTags: ["Chart"],
    }),

    getMapLoactions: builder.query({
      query: () => ({
        url: "/locations",
        method: "GET",
        headers: contentHeader(),
      }),
      providesTags: ["Chart"],
    }),
  }),
});

export const {
  useEvictionByTypeQuery,
  useEvictionByMonthQuery,
  usePreventionsByMonthQuery,
  useIncidenceByEntityQuery,
  useGetMapLoactionsQuery,
} = ChartApiSlice;
